module.exports = function() {
  return new Worker(__webpack_public_path__ + "bd77269d9049f54bc15c.worker.js");
};